import { useI18n } from '../../i18n';
import { FiGlobe, FiChevronDown } from 'react-icons/fi';

// 글로벌 함수 타입 선언
declare global {
  interface Window {
    openLanguageModal?: () => void;
  }
}

const LanguageSelector = () => {
  const { language } = useI18n();

  const handleClick = () => {
    // 기존 WIA 211언어 모달 열기
    if (window.openLanguageModal) {
      window.openLanguageModal();
    } else {
      console.warn('Language modal not loaded yet');
    }
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center gap-1.5 px-3 py-1.5 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-full hover:shadow-lg transition-all text-sm font-medium"
      title="Select Language"
    >
      <FiGlobe size={16} />
      <span>{language.toUpperCase()}</span>
      <FiChevronDown size={14} />
    </button>
  );
};

export default LanguageSelector;
